import _ from 'lodash';
import { messages } from '../../../messages';
import { LocaleType } from '../types';

export const getConsents = (locale: LocaleType, consentChecked: boolean) => {
  const consent = {
    site: 'atlassian',
    locale: locale.locale,
    formUrl: window.location.href,
    consents: [
      {
        key: 'termsOfService',
        displayedText: messages.eula.defaultMessage,
        granted: true
      },
      {
        key: 'privacyPolicy',
        displayedText: messages.eula.defaultMessage,
        granted: true
      },
      {
        key: 'generalMarketingOptIn',
        displayedText: messages.marketingConsent.defaultMessage,
        granted: false
      }
    ]
  };
  const needsConsent = _.get(
    locale,
    'localeRequiresMarketingCommunicationOptIn'
  );

  if (!needsConsent) {
    consent.consents[2].granted = true;
    consent.consents[2].displayedText = 'general consent implied';
  } else {
    consent.consents[2].granted = consentChecked;
  }

  return consent;
};
